import { RuntimeModel } from '../../components/runtime-view/types';

/**
 * UPS Runtime equation (Runtime in minutes based on load in Watts)
 * src: https://schneider.atlassian.net/wiki/spaces/PESV3/pages/2115274299/APC+Runtime+graph+and+chart BR1.1
 *
 */
export const runtime = ({
  bcurveScale,
  bcurveExpo,
  bcurveSlope,
  bcurveComp,
  vah,
  ptare,
}) => (x: number): number => {
  return (
    60
    * bcurveScale
    * ((vah / (x + ptare)) ** bcurveExpo
      - bcurveSlope
      + bcurveComp * ((x + ptare) / vah))
  );
};

export const getLoadStartPoint = (model: RuntimeModel): number => {
  return model.product.startPoint ?? model.product.pwrRated * 0.1;
};
